/**
 * Auth bridge for offline queue.
 *
 * Provides a way to get the current auth token without importing
 * the Supabase client directly (which would create circular deps
 * and is harder to mock in tests).
 *
 * The main app sets the getter via `setAuthTokenGetter` at startup.
 *
 * @module offline/auth-bridge
 */

type TokenGetter = () => Promise<string | null>;

let tokenGetter: TokenGetter = async () => null;

/**
 * Set the function used to obtain auth tokens for replaying queued mutations.
 * Called once at app startup from main.tsx.
 */
export function setAuthTokenGetter(getter: TokenGetter): void {
  tokenGetter = getter;
}

/**
 * Get the current auth token. Used by the offline queue when replaying mutations.
 */
export async function getAuthToken(): Promise<string | null> {
  return tokenGetter();
}
